const fr = {
  home: {
    title: 'Touchez pour lancer le quiz'
  },
  navigation: {
    back: 'Retour',
    start_message: "Touchez l'écran pour commencer"
  },
  quizGroup: {
    title: 'Le groupe RATP',
    description: 'Quiz sur le groupe RATP'
  },
  quizTransport: {
    title: 'L’histoire des transports en Île-de-France',
    description: 'Quiz sur l’histoire des transports en Île-de-France'
  },
  quizSolutionVille: {
    title: 'RATP Solutions Ville',
    description: 'Quiz sur RATP Solutions Ville'
  },
  quizInnovation: {
    title: 'Innovation Vivatech 2025',
    description: 'Quiz sur Innovation Vivatech 2025'
  },
  quizRatpDev: {
    title: 'RATP Dev',
    description: 'Quiz sur RATP Dev'
  },
  quizMetroMusic: {
    title: 'Musiciens du métro',
    description: 'Quiz sur Musiciens du métro'
  },
  quizJEP: {
    title: 'Journées Européennes du Patrimoine',
    description: 'Quiz sur les Journées Européennes du Patrimoine RATP'
  },
  quizGroupUMOP: {
    title: 'Quizz Groupe RATP\nUMOP 2026',
    description: 'Quiz Groupe RATP UMOP 2026'
  },
  quiz: {
    title: 'Quiz',
    question: 'Question',
    answer: 'Réponse',
    next: 'Suivant',
    end: 'Fin',
    correct_answer: 'Réponse correcte',
    incorrect_answer: 'Réponse incorrecte',
    question_number: 'Question {{question}} sur {{total}}',
    score_zero: 'Score : {{count}} point',
    score_one: 'Score : {{count}} point',
    score_other: 'Score : {{count}} points',
    end_page: {
      title: 'Fin du quiz',
      score: 'Score : {{count}} points',
      comment: 'Merci pour votre participation !',
      home_btn: "Retour à l'accueil"
    },
    quit_confirmation: {
      title: 'Êtes-vous sûr de vouloir quitter le quiz ?',
      message: 'Tous vos progrès seront perdus.',
      cancel: 'Annuler',
      confirm: 'Quitter'
    },

    1: {
      title: 'Quelle est la capitale de la France ?',
      good_answer_comment: "Et oui, c'est Paris ! Elle est la capitale depuis 1871.",
      bad_answer_comment: 'Dommage, la réponse correcte etait Paris !',
      options: {
        1: 'Paris',
        2: 'Lyon',
        3: 'Marseille',
        4: 'Toulouse'
      }
    },
    2: {
      title: 'Quel est le plus grand pays du monde ?',
      good_answer_comment: "Et oui, c'est la Russie ! Elle est la plus grande depuis 1991.",
      bad_answer_comment: 'Dommage, la réponse correcte etait la Russie !',
      options: {
        1: 'Russie',
        2: 'Chine',
        3: 'Etats-Unis',
        4: 'Canada'
      }
    },
    quizGroup1: {
      title: 'Le groupe RATP opère-t-il uniquement à Paris ?',
      good_answer_comment:
        'Exact ! Le groupe RATP opère en France et partout dans le monde, et exploite des réseaux multimodaux urbains et suburbains via plus de 100 contrats à travers ses filiales RATP Dev et RATP Cap Île-de-France.',
      bad_answer_comment:
        'Eh non, le groupe RATP opère en France et partout dans le monde, et exploite des réseaux multimodaux urbains et suburbains via plus de 100 contrats à travers ses filiales RATP Dev et RATP Cap Île-de-France.',
      options: {
        '1': 'Oui',
        '2': 'Non'
      }
    },
    quizGroup2: {
      title: 'Dans combien de pays le groupe RATP est-il implanté ?',
      good_answer_comment:
        'Bravo ! Le groupe RATP est implanté dans les 16 pays suivants : Afrique du Sud, Arabie Saoudite, Australie, Belgique, Canada, Chine RAS de Hong Kong, Égypte, États-Unis, France, Italie, Maroc, Philippines, Qatar, Serbie, Singapour, Suisse.',
      bad_answer_comment:
        'Raté ! Le groupe RATP est implanté dans les 16 pays suivants : Afrique du Sud, Arabie Saoudite, Australie, Belgique, Canada, Chine RAS de Hong Kong, Égypte, États-Unis, France, Italie, Maroc, Philippines, Qatar, Serbie, Singapour, Suisse. ',
      options: {
        '1': '10',
        '2': '16',
        '3': '20',
        '4': '25'
      }
    },
    quizGroup3: {
      title:
        'Le groupe RATP déploie de la fibre optique en Île-de-France via sa filiale RATP Connect. Combien de kilomètres ?',
      good_answer_comment:
        'Oui ! RATP Connect a déployé 170 000 km de fibre optique en Île-de-France. Il est responsable du déploiement et de la maintenance de ce réseau de fibre optique qui contribue à la connectivité et au dynamisme économique de la région.',
      bad_answer_comment:
        'Non, RATP Connect a déployé 170 000 km de fibre optique en Île-de-France. Il est responsable du déploiement et de la maintenance de ce réseau de fibre optique qui contribue à la connectivité et au dynamisme économique de la région.',
      options: {
        '1': '1 500 km',
        '2': '15 000 km',
        '3': 'plus de 150 000 km'
      }
    },
    quizGroup4: {
      title: 'Combien de modes de transport le groupe RATP exploite-t-il quotidiennement ?',
      good_answer_comment:
        'Exact ! Le groupe RATP exploite 9 modes de transport au quotidien : métro, tramway, bus urbain et interurbain, train régional, sightseeing, navette maritime, transport à la demande, câble et véhicule autonome. ',
      bad_answer_comment:
        'Presque ! Le groupe RATP exploite 9 modes de transport au quotidien : métro, tramway, bus urbain et interurbain, train régional, sightseeing, navette maritime, transport à la demande, câble et véhicule autonome. ',
      options: {
        '1': '5',
        '2': '7',
        '3': '9',
        '4': '11'
      }
    },
    quizGroup5: {
      title: 'Quel est le nombre approximatif de collaborateurs du groupe RATP ?',
      good_answer_comment:
        'Bien vu ! Le groupe RATP compte plus de 73 500 collaborateurs, dont un quart à l’international.',
      bad_answer_comment:
        'Ce n’est pas tout à fait ça. Le groupe RATP compte plus de 73 500 collaborateurs, dont un quart à l’international.',
      options: {
        '1': 'Moins de 50 000',
        '2': 'Entre 50 000 et 70 000',
        '3': 'Entre 70 000 et 80 000',
        '4': 'Plus de 80 000'
      }
    },
    quizGroup6: {
      title: 'Quel mode de transport n’est pas exploité par le groupe RATP ?',
      good_answer_comment:
        'Exact, Le groupe RATP exploite 9 modes de transport au quotidien : métro, tramway, bus urbain et interurbain, train régional, sightseeing, navette maritime, transport à la demande, câble et véhicule autonome. ',
      bad_answer_comment:
        'Non, Le groupe RATP exploite 9 modes de transport au quotidien : métro, tramway, bus urbain et interurbain, train régional, sightseeing, navette maritime, transport à la demande, câble et véhicule autonome. ',
      options: {
        '1': 'Métro',
        '2': 'Tramway',
        '3': 'Avion',
        '4': 'Bus urbain'
      }
    },
    quizGroup7: {
      title: 'Combien de métiers différents propose le groupe RATP ?',
      good_answer_comment:
        'C’est juste ! Le groupe RATP propose 270 métiers différents. Voici quelques exemples de métiers présents au sein du groupe : conducteur de métro, technicien de maintenance, ingénieur en systèmes de transport, responsable de la sécurité, chargé de communication, gestionnaire de projet.',
      bad_answer_comment:
        'Presque ! Le groupe RATP propose 270 métiers différents. Voici quelques exemples de métiers présents au sein du groupe : conducteur de métro, technicien de maintenance, ingénieur en systèmes de transport, responsable de la sécurité, chargé de communication, gestionnaire de projet.',
      options: {
        '1': '30 métiers',
        '2': '50 métiers',
        '3': '100 métiers',
        '4': 'Plus de 200 métiers'
      }
    },
    quizGroup8: {
      title: 'Le groupe RATP est-il également dans le secteur immobilier ?',
      good_answer_comment:
        'Bonne réponse ! Le groupe RATP est actif dans le secteur immobilier à travers plusieurs initiatives et filiales. Notamment avec RATP Habitat dans la gestion de plus de 9 300 logements sociaux et intermédiaires en Île-de-France. Et avec RATP Real Estate dans le développement de projets immobiliers mixtes, incluant la transformation de sites industriels et tertiaires en logements, commerces et haltes-garderies.',
      bad_answer_comment:
        'Eh si, le groupe RATP est actif dans le secteur immobilier à travers plusieurs initiatives et filiales. Notamment avec RATP Habitat dans la gestion de plus de 9 300 logements sociaux et intermédiaires en Île-de-France. Et avec RATP Real Estate dans le développement de projets immobiliers mixtes, incluant la transformation de sites industriels et tertiaires en logements, commerces et haltes-garderies.',
      options: {
        '1': 'Oui',
        '2': 'Non'
      }
    },
    quizGroup9: {
      title: 'Quels services propose la filiale RATP Solutions Ville ?',
      good_answer_comment:
        'Exact ! Filiale dédiée aux services urbains, RATP Solutions Ville regroupe les expertises de RATP Habitat, RATP Real Estate, RATP Connect et RATP Capital Innovation. Cette filiale s’adresse aux villes, territoires et entreprises sur les secteurs de l’immobilier, des télécoms, de l’énergie, de la logistique urbaine et des nouvelles mobilités.',
      bad_answer_comment:
        'Pas tout à fait ! Filiale dédiée aux services urbains, RATP Solutions Ville regroupe les expertises de RATP Habitat, RATP Real Estate, RATP Connect et RATP Capital Innovation. Cette filiale s’adresse aux villes, territoires et entreprises sur les secteurs de l’immobilier, des télécoms, de l’énergie, de la logistique urbaine et des nouvelles mobilités.',
      options: {
        '1': 'Immobilier',
        '2': 'Télécoms',
        '3': 'Energie',
        '4': 'Logistique urbaine',
        '5': 'Nouvelles mobilités'
      }
    },
    quizGroup10: {
      title: 'En quelle année a été créée RATP Dev ?',
      good_answer_comment: 'Bravo ! RATP Dev a été créée en 2002.',
      bad_answer_comment: 'Non, c’était en 2002 que RATP Dev a été fondée.',
      options: {
        '1': '1970',
        '2': '1995',
        '3': '2002',
        '4': '2017'
      }
    },
    quizGroup11: {
      title: 'A qui s’adresse l’offre d’ingénierie de transition énergétique de la nouvelle filiale RATP Expertises ?',
      good_answer_comment: 'Bravo ! Notre offre adresse l’ensemble des besoins des projets de la conception à la réalisation.',
      bad_answer_comment: 'Non, Notre offre adresse l’ensemble des besoins des projets de la conception à la réalisation.',
      options: {
        '1': 'Les Autorités Organisatrices de la Mobilité',
        '2': 'Les Industriels',
        '3': 'Les Opérateurs'
      }
    },
    quizGroup12: {
      title:
        'La mission de la Fondation RATP est de favoriser l’insertion sociale de publics urbains en situation de fragilité économique et sociale. Quels sont les 2 programmes dans lesquels cette mission se décline ?',
      good_answer_comment:
        'Bravo ! L’action de la Fondation s’inscrit en prolongement des activités du groupe RATP et en cohérence avec sa raison d’être « S’engager chaque jour pour une meilleure qualité de ville ». C’est pourquoi, ses 2 programmes visent à permettre aux habitants en situation de fragilité économique ou sociale, dans les territoires d’implantation du Groupe, de s’insérer dans la vie professionnelle et dans la vie en ville.',
      bad_answer_comment:
        'Pas tout à fait ! L’action de la Fondation s’inscrit en prolongement des activités du groupe RATP et en cohérence avec sa raison d’être « S’engager chaque jour pour une meilleure qualité de ville ». C’est pourquoi, ses 2 programmes visent à permettre aux habitants en situation de fragilité économique ou sociale, dans les territoires d’implantation du Groupe, de s’insérer dans la vie professionnelle et dans la vie en ville.',
      options: {
        '1': 'Faciliter l’insertion professionnelle',
        '2': 'Eduquer à la citoyenneté',
        '3': 'Favoriser l’égalité d’accès aux ressources et aux opportunités de la ville',
        '4': 'Donner accès à la culture'
      }
    },
    quizTransport1: {
      title: 'En quelle année a eu lieu le premier coup de pioche du RER A ?',
      good_answer_comment: 'Bonne réponse ! Les travaux du RER A ont commencé en 1962.',
      bad_answer_comment: 'Non, le premier coup de pioche du RER A a eu lieu en 1962.',
      options: {
        '1': '1961',
        '2': '1962',
        '3': '1964',
        '4': '1960'
      }
    },
    quizTransport2: {
      title: 'Dans quelle station a été installé le premier trottoir roulant en 1964 ?',
      good_answer_comment:
        'Exact ! C’est à Montparnasse que le premier trottoir roulant a été installé.',
      bad_answer_comment: 'Presque ! C’était à Montparnasse en 1964.',
      options: {
        '1': 'Châtelet',
        '2': 'Montparnasse',
        '3': 'Auber',
        '4': 'Saint-Germain en Laye'
      }
    },
    quizTransport3: {
      title: 'En quelle année les premiers péages magnétiques ont-ils été installés ?',
      good_answer_comment: 'Bonne réponse ! Les péages magnétiques sont apparus en 1968.',
      bad_answer_comment: 'Raté, c’était en 1968 que les péages magnétiques ont été installés.',
      options: {
        '1': '1957',
        '2': '1968',
        '3': '1975',
        '4': '1981'
      }
    },
    quizTransport4: {
      title: 'En quelle année a été mis en service le T1 entre Bobigny et Saint-Denis ?',
      good_answer_comment: 'Bien joué ! Le T1 a été inauguré en 1992.',
      bad_answer_comment: 'Non, c’était en 1992 que le T1 a été mis en service.',
      options: {
        '1': '1979',
        '2': '1985',
        '3': '1992',
        '4': '1996'
      }
    },
    quizTransport5: {
      title:
        'En quelle année la nouvelle identité de la RATP est-elle présentée avec son logo présentant à la fois un visage et la Seine ?',
      good_answer_comment: 'Oui ! Le logo actuel de la RATP date de 1992.',
      bad_answer_comment: 'La bonne réponse était 1992, pour le nouveau logo RATP.',
      options: {
        '1': '1982',
        '2': '1987',
        '3': '1992',
        '4': '1998'
      }
    },
    quizTransport6: {
      title: 'En quelle année a été inaugurée la ligne 14 ?',
      good_answer_comment: 'Exact ! La ligne 14 a été inaugurée en 1998.',
      bad_answer_comment: 'Non, c’était en 1998 que la ligne 14 a ouvert ses portes.',
      options: {
        '1': '1995',
        '2': '1998',
        '3': '2000',
        '4': '2024'
      }
    },
    quizTransport7: {
      title: 'En quelle année la ligne 1 a-t-elle été automatisée ?',
      good_answer_comment: 'Bravo ! La ligne 1 a été automatisée en 2011.',
      bad_answer_comment: 'Ce n’est pas ça. La ligne 1 a été automatisée en 2011.',
      options: {
        '1': '2000',
        '2': '2007',
        '3': '2011',
        '4': '2016'
      }
    },
    quizTransport8: {
      title: 'En quelle année a été créée la RATP ?',
      good_answer_comment: 'Oui ! La RATP a été créée en 1949.',
      bad_answer_comment: 'Non, la RATP est née en 1949.',
      options: {
        '1': '1905',
        '2': '1939',
        '3': '1949',
        '4': '1960'
      }
    },
    quizTransport9: {
      title: 'En quelle année a été inaugurée la ligne 1 du métro parisien ?',
      good_answer_comment: 'Bonne réponse ! La ligne 1 a été inaugurée en 1900.',
      bad_answer_comment: 'La bonne réponse était 1900.',
      options: {
        '1': '1895',
        '2': '1900',
        '3': '1905',
        '4': '1910'
      }
    },
    quizTransport10: {
      title: 'En quelle année la 1ère classe a-t-elle disparu du métro parisien ?',
      good_answer_comment: 'Exact ! La 1ère classe a disparu en 1985.',
      bad_answer_comment: 'Presque ! C’était en 1985 que la 1ère classe a disparu.',
      options: {
        '1': '1991',
        '2': '1975',
        '3': '2000',
        '4': '1985'
      }
    },
    quizSolutionVille1: {
      title: 'Quelle est la mission principale de RATP Solutions Ville, filiale du groupe RATP ?',
      good_answer_comment:
        'Bonne réponse ! RATP Solutions Ville aide à relever les défis de la transition écologique urbaine.',
      bad_answer_comment:
        'La bonne réponse était : proposer des services urbains aux villes pour la transition écologique.',
      options: {
        '1': 'Répondre aux appels d’offre dans le cadre de l’ouverture à la concurrence des transports publics portée par Île-de-France Mobilités et opérer les réseaux de transport qu’elle remporte',
        '2': 'Proposer des services urbains aux villes, collectivités et entreprises sur-mesure pour relever le défi de la transition écologique des villes',
        '3': 'Opérer des réseaux de transport urbain et interurbain en dehors du réseau « historique » de la RATP en région parisienne',
        '4': 'Agir en faveur de l’insertion sociale, en initiant et en soutenant des initiatives d’intérêt général'
      }
    },
    quizSolutionVille2: {
      title:
        'La filiale RATP Solutions Ville propose aux collectivités et aux entreprises des solutions intégrées autour de cinq secteurs-clés dans lesquels le groupe RATP a déjà fait la preuve de son excellence : l’immobilier, les télécoms, la logistique urbaine, les nouvelles mobilités et … ? ',
      good_answer_comment: 'Exact ! L’énergie complète les cinq secteurs-clés.',
      bad_answer_comment: 'C’est l’énergie qui complète les secteurs clés de RATP Solutions Ville.',
      options: {
        '1': 'La santé',
        '2': 'Le sport',
        '3': 'L’énergie',
        '4': 'L’éducation'
      }
    },
    quizSolutionVille3: {
      title:
        'RATP Solutions Ville accueille deux structures dédiées aux activités immobilières (logements sociaux, promotion du logement intermédiaire, gestion de grands projets d’insertion urbaine, gestion de sites industriels et tertiaires, gestion de sites de corpoworking, co-promotion immobilière). Quelles sont-elles ?',
      good_answer_comment: 'Bien vu ! Ce sont RATP Habitat et RATP Real Estate.',
      bad_answer_comment: 'Non, les structures immobilières sont RATP Habitat et RATP Real Estate.',
      options: {
        '1': 'RATP Cap Ile-de-France et RATP Dev',
        '2': 'RATP Maintenance Service et RATP Sécurité Expertises',
        '3': 'RATP Capital Innovation et RATP Connect',
        '4': 'RATP Habitat et RATP Real Estate'
      }
    },
    quizSolutionVille4: {
      title:
        'Filiale de RATP Solutions Ville et leader français de la fibre noire, RATP Connect déploie depuis plus de 20 ans le plus important réseau optique d’Île-de-France à partir des infrastructures du métro et du RER. Combien de kilomètres de fibre optique sont déployées en Ile-de-France par RATP Connect ',
      good_answer_comment: 'Exact ! 170 000 km de fibre ont été déployés par RATP Connect.',
      bad_answer_comment: 'Ce sont 170 000 km de fibre optique qui ont été déployés.',
      options: {
        '1': '170 000 km',
        '2': '27 000 km',
        '3': '1200 km',
        '4': '640 km'
      }
    },
    quizSolutionVille5: {
      title: "Quel est l'objectif principal de RATP Capital Innovation, la filiale d’investissement du groupe RATP ?",
      good_answer_comment:
        'Bravo ! L’objectif est bien d’investir dans des projets durables et urbains.',
      bad_answer_comment:
        'La bonne réponse est l’investissement dans la mobilité durable, l’immobilier urbain et la logistique.',
      options: {
        '1': 'Investir uniquement dans des entreprises liées au secteur du transport public',
        '2': "Investir dans des projets œuvrant dans les secteurs de la mobilité durable, de l'immobilier urbain et de la logistique du dernier kilomètre",
        '3': 'Financer des projets exclusivement dans le domaine de la technologie informatique',
        '4': 'Investir dans les industries pétrolières et gazières pour soutenir la transition énergétique'
      }
    },
    quizSolutionVille6: {
      title: 'RATP Habitat est la filiale immobilière sociale du groupe RATP. Elle construit, réhabilite et gère un patrimoine de logements, commerces et résidences en Île-de-France. Quelle est sa mission principale ? ',
      good_answer_comment: 'Exact ! RATP Habitat vise à loger les travailleurs essentiels.',
      bad_answer_comment:
        'Ce n’est pas ça. Leur mission principale est de loger les travailleurs essentiels en ville.',
      options: {
        '1': 'Offrir des logements exclusivement aux étudiants étrangers',
        '2': 'Construire des bureaux pour les collectivités locales',
        '3': 'Vendre des logements privés',
        '4': 'Loger les travailleurs essentiels franciliens en cœur de ville'
      }
    },
    quizSolutionVille7: {
      title:
        'Les centres bus sont des infrastructures de la RATP utilisées principalement pour l’exploitation des lignes, le remisage et la maintenance des bus. Cependant, en journée, certaines zones de ces centres sont inoccupées. Comment RATP Solutions Ville valorise-t-elle ces espaces ? ',
      good_answer_comment:
        'Bonne réponse ! Les espaces sont utilisés pour la livraison du dernier kilomètre.',
      bad_answer_comment:
        'Non, c’est pour accueillir des activités de livraison du dernier kilomètre.',
      options: {
        '1': 'En les transformant en parkings pour particuliers',
        '2': 'En accueillant des activités de livraison du dernier kilomètre',
        '3': 'En y installant des espaces de coworking pour les startups',
        '4': 'En y organisant des événements culturels'
      }
    },
    quizSolutionVille8: {
      title:
        'Quels sont les gains environnementaux mesurés grâce à l’utilisation des microhubs de livraison dans les centres bus ?',
      good_answer_comment:
        'Exact ! Les microhubs permettent de très fortes réductions de polluants.',
      bad_answer_comment: 'Non, c’est 80 % de GES, 49 % de particules fines et 80 % de NOx.',
      options: {
        '1': '20 % de réduction des émissions de GES et 10 % de NOx',
        '2': '60 % de réduction des particules fines et 30 % de GES',
        '3': '80 % de réduction des émissions de GES, 49 % de particules fines et 80 % de NOx',
        '4': '10 % de réduction de toutes les émissions polluantes'
      }
    },
    quizInnovation1: {
      title: 'Dans combien de pays le Groupe RATP est-il présent ?',
      good_answer_comment: 'Exact ! Le Groupe RATP est présent dans 16 pays via RATP Dev.',
      bad_answer_comment: 'Non, la bonne réponse est 16 pays.',
      options: {
        '1': '1',
        '2': '7',
        '3': '16'
      }
    },
    quizInnovation2: {
      title: 'Combien de modes de transport la RATP opère-t-elle ?',
      good_answer_comment: 'Bravo ! La RATP opère 9 modes de transport différents.',
      bad_answer_comment: 'Raté, c’est 9 modes de transport que la RATP exploite.',
      options: {
        '1': '3',
        '2': '5',
        '3': '9'
      }
    },
    quizInnovation3: {
      title: 'Combien de projets d’innovation sont pilotés chaque année par la RATP ?',
      good_answer_comment:
        'Bonne réponse ! Environ 300 projets d’innovation sont pilotés chaque année.',
      bad_answer_comment: 'Non, c’est 300 projets d’innovation chaque année.',
      options: {
        '1': '50',
        '2': '150',
        '3': '300'
      }
    },
    quizInnovation4: {
      title: 'A date, avec combien de startups la RATP a-t-elle déjà collaboré ?',
      good_answer_comment: 'Exact ! Plus de 270 collaborations avec des startups.',
      bad_answer_comment:
        'Ce n’est pas ça. C’est 270 startups avec lesquelles la RATP a collaboré.',
      options: {
        '1': '60',
        '2': '270',
        '3': '1200'
      }
    },
    quizInnovation5: {
      title:
        'Comment appelle-t-on les équipements portés par les mainteneurs pour réduire la pénibilité ?',
      good_answer_comment: 'Correct ! Ce sont les exosquelettes.',
      bad_answer_comment: 'Non, ce sont des exosquelettes.',
      options: {
        '1': 'Les gilets pare-chocs',
        '2': 'Les équipements bioniques',
        '3': 'Les exosquelettes'
      }
    },
    quizInnovation6: {
      title: 'En 2023, la RATP a expérimenté un bus autonome sur quelle ligne ?',
      good_answer_comment: 'Bravo ! Il s’agit bien de la ligne 393.',
      bad_answer_comment: 'Non, c’était la ligne 393.',
      options: {
        '1': 'Ligne 393 | Thiais – Carrefour de la Résistance ↔ Sucy-Bonneuil RER',
        '2': 'Ligne 39 | Issy-les-Moulineaux – Frères voisins ↔ Gare du Nord',
        '3': 'Ligne 4602 | Centre Commercial Ulis 2 ↔ Gare de Massy-Palaiseau'
      }
    },
    quizInnovation7: {
      title: 'Quel est l’objectif principal du programme Bus 2025 ?',
      good_answer_comment: 'Exact ! Le programme vise une flotte 100 % propre d’ici 2025.',
      bad_answer_comment:
        'Raté, l’objectif est la conversion complète à l’électrique ou biométhane.',
      options: {
        '1': 'Réduire de 25 % le nombre de bus en circulation',
        '2': 'Remplacer uniquement les bus diesel les plus anciens',
        '3': 'Convertir 100 % de la flotte de bus à l’électrique ou au biométhane d’ici 2025'
      }
    },
    quizInnovation8: {
      title: 'Comment appelle-t-on les 25 000 m3 d’eau récupérés chaque jour par la RATP ?',
      good_answer_comment: 'Bonne réponse ! Ce sont les eaux d’exhaure.',
      bad_answer_comment: 'Non, ce sont les eaux d’exhaure.',
      options: {
        '1': 'Les eaux d’exhaure',
        '2': 'Les eaux pluviales',
        '3': 'Les eaux grises'
      }
    },
    quizInnovation9: {
      title: 'Quelle est la part des déchets valorisés par la RATP ?',
      good_answer_comment: 'Exact ! 99,75 % des déchets sont valorisés.',
      bad_answer_comment: 'Presque ! C’est 99 % de déchets valorisés.',
      options: {
        '1': '32%',
        '2': '54%',
        '3': '99%'
      }
    },
    quizInnovation10: {
      title: 'Pourquoi le RER A a-t-il été équipé de garnitures de freinage « green » en 2024 ?',
      good_answer_comment: 'Bien vu ! C’est pour la qualité de l’air dans les espaces souterrains.',
      bad_answer_comment: 'Non, c’est pour améliorer la qualité de l’air.',
      options: {
        '1': 'Pour réduire le coût d’entretien des freins',
        '2': 'Pour améliorer la qualité de l’air dans les espaces souterrains',
        '3': 'Pour rendre le freinage totalement silencieux'
      }
    },
    quizInnovation11: {
      title: 'Dans quelle grande ville française le Groupe RATP n’est-il PAS présent ?',
      good_answer_comment: 'Exact ! Le Groupe n’est pas présent à Strasbourg.',
      bad_answer_comment: 'Non, la RATP n’est pas présente à Strasbourg.',
      options: {
        '1': 'Brest',
        '2': 'Lyon',
        '3': 'Strasbourg',
        '4': 'Toulon'
      }
    },
    quizRatpDev1: {
      title: 'Quelle est la mission principale de RATP Dev ?',
      good_answer_comment:
        'Bravo ! RATP Dev est la filiale internationale du groupe RATP, leader des réseaux de rail urbain à grande capacité. RATP Dev opère et maintient notamment des réseaux de transports dans plus de 50 villes en France.',
      bad_answer_comment:
        'Non, RATP Dev est la filiale internationale du groupe RATP, leader des réseaux de rail urbain à grande capacité. RATP Dev opère et maintient notamment des réseaux de transports dans plus de 50 villes en France.',
      options: {
        '1': 'Fabriquer des trains',
        '2': 'Développer des jeux vidéo',
        '3': 'Exploiter et maintenir des réseaux de transport publics en France et à l’international',
        '4': 'Gérer les infrastructures ferroviaires françaises'
      }
    },
    quizRatpDev2: {
      title: 'Dans combien de pays RATP Dev est-elle présente ?',
      good_answer_comment: 'Bonne réponse ! RATP Dev est présente sur 5 continents et dans 17 pays : Afrique du Sud, Arabie Saoudite, Australie, Belgique, Canada, Chine RAS de Hong Kong, Égypte, États-Unis, France, Italie, Maroc, Philippines, Royaume-Uni, Qatar, Serbie, Singapour, Suisse. ',
      bad_answer_comment: 'Non, RATP Dev est présente sur 5 continents et dans 17 pays : Afrique du Sud, Arabie Saoudite, Australie, Belgique, Canada, Chine RAS de Hong Kong, Égypte, États-Unis, France, Italie, Maroc, Philippines, Royaume-Uni, Qatar, Serbie, Singapour, Suisse. ',
      options: {
        '1': 'Moins de 7',
        '2': 'Environ 17',
        '3': 'Plus de 27',
        '4': 'Plus de 37'
      }
    },
    quizRatpDev3: {
      title: 'Combien de collaborateurs compte RATP Dev dans le monde ?',
      good_answer_comment:
        'Ce sont 25 000 salariés qui mettent leur passion, leur détermination, et leur humilité au service des clients.',
      bad_answer_comment: 'RATP Dev compte 25 000 salariés dans le monde.',
      options: {
        '1': '2 000',
        '2': '5 000',
        '3': '10 000',
        '4': '25 000'
      }
    },
    quizRatpDev4: {
      title: 'Lequel(s) de ces modes de transport est/sont exploité(s) par RATP Dev ?',
      good_answer_comment:
        'Bonne réponse ! RATP Dev exploite une large gamme de modes de transport, hors transport aérien : métros, tramways, bus, navettes fluviales et maritimes, funiculaires, et bien d’autres encore.',
      bad_answer_comment:
        'Non, RATP Dev exploite une large gamme de modes de transport, hors transport aérien : métros, tramways, bus, navettes fluviales et maritimes, funiculaires, et bien d’autres encore.',
      options: {
        '1': 'Métro',
        '2': 'Tramway',
        '3': 'Navette fluviale',
        '4': 'Avion'
      }
    },
    quizRatpDev5: {
      title:
        'En 2024, quelle métropole française a attribué l’exploitation de son réseau de métros, tramways, funiculaire, Rhône Express et navettes fluviales à RATP Dev ?',
      good_answer_comment: 'Exact ! En 2024, la métropole de Lyon a confié à RATP Dev l’exploitation de son réseau TCL, incluant métro, tramway, funiculaire, Rhône Express et navettes fluviales.',
      bad_answer_comment: 'Non! En 2024, la métropole de Lyon a confié à RATP Dev l’exploitation de son réseau TCL, incluant métro, tramway, funiculaire, Rhône Express et navettes fluviales.',
      options: {
        '1': 'Toulouse',
        '2': 'Lyon',
        '3': 'Toulon',
        '4': 'Nice'
      }
    },
    quizRatpDev6: {
      title: 'Quel(s) projet(s) emblématique(s) de métro automatique RATP Dev opère-t-elle au Moyen-Orient ?',
      good_answer_comment:
        'Bonne réponse !RATP Dev assure l’exploitation des métros automatiques de Riyad, en Arabie saoudite, et de Doha, au Qatar, deux projets emblématiques au cœur du développement des mobilités urbaines dans la région.',
      bad_answer_comment: 'Raté, RATP Dev assure l’exploitation des métros automatiques de Riyad, en Arabie saoudite, et de Doha, au Qatar, deux projets emblématiques au cœur du développement des mobilités urbaines dans la région.',
      options: {
        '1': 'Le métro de Dubaï',
        '2': 'Le métro de Riyad',
        '3': 'Le métro de Doha',
        '4': 'le métro de Abou Dabi'
      }
    },
    quizRatpDev7: {
      title: 'Quelle est la particularité du réseau RATP Dev de La Roche-sur-Yon ?',
      good_answer_comment: 'Parfait !RATP Dev avec sa filiale CTY de la Roche-sur-Yon a créé en 2024 son tout premier centre de formation dédié à la maintenance des bus à hydrogène. Ce centre accueille depuis mars 2025 les premiers salariés formés à ce mode durable.',
      bad_answer_comment: 'Ce n’était pas ça. RATP Dev avec sa filiale CTY de la Roche-sur-Yon a créé en 2024 son tout premier centre de formation dédié à la maintenance des bus à hydrogène. Ce centre accueille depuis mars 2025 les premiers salariés formés à ce mode durable.',
      options: {
        '1': 'Il propose la location de skateboard en libre-service ',
        '2': 'Il dispose de navettes autonomes',
        '3': 'Il intègre un centre de formation dédié à la maintenance des bus à hydrogène',
        '4': 'Il offre un mode de transport fluvial et respectueux de l’environnement'
      }
    },
    quizRatpDev8: {
      title: 'Quelle est la particularité du projet Jurong Region Line à Singapour ?',
      good_answer_comment: 'Exact ! La Jurong Region Line, métro automatisé et surélevé, incarne une réponse innovante aux défis de mobilité, de densification et de transition énergétique en milieu urbain asiatique.',
      bad_answer_comment:
        'Non, La Jurong Region Line, métro automatisé et surélevé, incarne une réponse innovante aux défis de mobilité, de densification et de transition énergétique en milieu urbain asiatique.',
      options: {
        '1': "Il s'agit d'une ligne souterraine reliant l’aéroport",
        '2': 'C’est la première ligne de tramway de la ville',
        '3': 'Elle est entièrement automatisée et aérienne',
        '4': 'Elle est réservée au fret'
      }
    },
    quizRatpDev9: {
      title: 'Quels réseaux de transport RATP Dev gère-t-elle à Riyad, en Arabie saoudite  ?',
      good_answer_comment: 'Bien joué ! À Riyad, RATP Dev opère à la fois deux lignes de métro automatique et un réseau de bus à haut niveau de service (BHNS), dans le cadre du tout premier système de transport public intégré du Royaume. Ce projet emblématique, mené en partenariat avec SAPTCO, illustre l’expertise de RATP Dev dans la mise en œuvre de solutions de mobilité durables, innovantes et adaptées aux enjeux de transformation urbaine du plan Vision 2030.',
      bad_answer_comment:
        'Non. À Riyad, RATP Dev opère à la fois deux lignes de métro automatique et un réseau de bus à haut niveau de service (BHNS), dans le cadre du tout premier système de transport public intégré du Royaume. Ce projet emblématique, mené en partenariat avec SAPTCO, illustre l’expertise de RATP Dev dans la mise en œuvre de solutions de mobilité durables, innovantes et adaptées aux enjeux de transformation urbaine du plan Vision 2030.',
      options: {
        '1': 'Métro automatique',
        '2': 'Tramway',
        '3': 'Bus à Haut niveau de Service',
        '4': 'Ferroviaire'
      }
    },
    quizRatpDev10: {
      title: 'Dans quel pays, RATP Dev a formé les premières femmes conductrices de train ?',
      good_answer_comment: 'Exact ! C’est en Egypte et plus précisément au Caire, que RATP Dev a formé les premières femmes conductrices de train. Elles conduisent ainsi le New Capital Train (Light Rail Transit).',
      bad_answer_comment: 'Presque, c’est en Egypte et plus précisément au Caire, que RATP Dev a formé les premières femmes conductrices de train. Elles conduisent ainsi le New Capital Train (Light Rail Transit).',
      options: {
        '1': 'Egypte',
        '2': 'Maroc',
        '3': 'Italie',
        '4': 'Hong Kong'
      }
    },
    quizRatpDevMobco1: {
      title: 'Quelle est la « vision » de RATP Dev ?',
      good_answer_comment:
        'Nous parlons de « choix naturel » parce que nous voulons que le transport public devienne une évidence pour les villes et les voyageurs. Un choix spontané, parce qu\'il répond à leurs attentes, leurs valeurs et leurs besoins.',
      bad_answer_comment:
        'Non, nous parlons de « choix naturel » parce que nous voulons que le transport public devienne une évidence pour les villes et les voyageurs. Un choix spontané, parce qu\'il répond à leurs attentes, leurs valeurs et leurs besoins.',
      options: {
        '1': 'Le choix naturel',
        '2': 'La mobilité pour tous',
        '3': 'Le choix durable',
        '4': 'Le meilleur de la mobilité'
      }
    },
    quizRatpDevMobco2: {
      title: 'Aujourd\'hui, dans combien de pays RATP Dev opère-t-elle ?',
      good_answer_comment: 'RATP Dev est présente dans 16 pays et 5 continents.',
      bad_answer_comment: 'Non, RATP Dev est présente dans 16 pays et 5 continents.',
      options: {
        '1': '9',
        '2': '16',
        '3': '12',
        '4': '18'
      }
    },
    quizRatpDevMobco3: {
      title: 'Quel est le nombre de voyages effectués chaque jour sur les réseaux de RATP Dev dans le monde ?',
      good_answer_comment:
        'À travers plus de 120 réseaux de transport, RATP Dev comptabilise au quotidien plus de 4,5 millions de voyages dans le monde.',
      bad_answer_comment:
        'Non, à travers plus de 120 réseaux de transport, RATP Dev comptabilise au quotidien plus de 4,5 millions de voyages dans le monde.',
      options: {
        '1': 'Plus de 2 millions',
        '2': 'Plus de 3 millions',
        '3': 'Plus de 4 millions',
        '4': 'Plus de 5 millions'
      }
    },
    quizRatpDevMobco4: {
      title: 'Cherchez l\'intrus ! Lequel de ces modes de transport N\'EST PAS exploité par RATP Dev ?',
      good_answer_comment:
        'RATP Dev exploite des réseaux de métro, du ferroviaire, des tramways, des bus, des navettes maritimes, des téléphériques... mais aucun dans l\'aérien !',
      bad_answer_comment:
        'Non, RATP Dev exploite des réseaux de métro, du ferroviaire, des tramways, des bus, des navettes maritimes, des téléphériques... mais aucun dans l\'aérien !',
      options: {
        '1': 'Métro',
        '2': 'Tramway',
        '3': 'Avion',
        '4': 'Navette maritime'
      }
    },
    quizRatpDevMobco5: {
      title: 'Début 2026, quelle région française a confié à RATP Dev l\'exploitation d\'une partie de son réseau ferroviaire ?',
      good_answer_comment:
        'La région Normandie a confié à RATP Dev l\'exploitation de l\'Étoile de Caen, ensemble stratégique de dix lignes ferroviaires autour de l\'agglomération caennaise, à compter de juillet 2027.',
      bad_answer_comment:
        'Non, la région Normandie a confié à RATP Dev l\'exploitation de l\'Étoile de Caen, ensemble stratégique de dix lignes ferroviaires autour de l\'agglomération caennaise, à compter de juillet 2027.',
      options: {
        '1': 'Bretagne',
        '2': 'Normandie',
        '3': 'Occitanie',
        '4': 'Corse'
      }
    },
    quizRatpDevMobco6: {
      title: 'Sur le réseau d\'Angers, quels modes de transport sont opérés par RATP Dev ?',
      good_answer_comment:
        'Avec plus de 43 millions de passagers par an, le réseau de la ville d\'Angers, opéré par RATP Dev, propose une offre de transport multimodale avec notamment 3 lignes de tramway, 31 lignes de bus, du transport à la demande ou encore une offre de vélo en libre-service.',
      bad_answer_comment:
        'Non, avec plus de 43 millions de passagers par an, le réseau de la ville d\'Angers, opéré par RATP Dev, propose une offre de transport multimodale avec notamment 3 lignes de tramway, 31 lignes de bus, du transport à la demande ou encore une offre de vélo en libre-service.',
      options: {
        '1': 'Tramway',
        '2': 'Bus',
        '3': 'Navette fluviale',
        '4': 'Vélo'
      }
    },
    quizRatpDevMobco7: {
      title: 'Quel mode de transport circulera sur la Suburban Rail Loop East à Melbourne, dont RATP Dev a remporté l\'exploitation fin 2025 ?',
      good_answer_comment:
        'RATP Dev apportera, durant toute la phase de construction, son expertise de futur exploitant de la ligne de métro 100 % automatique, puis en assurera l\'exploitation et la maintenance.',
      bad_answer_comment:
        'Non, RATP Dev apportera, durant toute la phase de construction, son expertise de futur exploitant de la ligne de métro 100 % automatique, puis en assurera l\'exploitation et la maintenance.',
      options: {
        '1': 'Une ligne ferroviaire',
        '2': 'Un réseau de BHNS',
        '3': 'Une ligne de métro automatique',
        '4': 'Un réseau de navettes TAD'
      }
    },
    quizRatpDevMobco8: {
      title: 'Combien de filiales compte la Business Unit France-Suisse de RATP Dev ?',
      good_answer_comment:
        'RATP Dev compte aujourd\'hui plus de 50 filiales sur la zone France-Suisse. Depuis plus de 20 ans, nous accompagnons ces collectivités pour proposer des solutions de mobilité ambitieuses.',
      bad_answer_comment:
        'Non, RATP Dev compte aujourd\'hui plus de 50 filiales sur la zone France-Suisse. Depuis plus de 20 ans, nous accompagnons ces collectivités pour proposer des solutions de mobilité ambitieuses.',
      options: {
        '1': 'Plus de 30',
        '2': 'Plus de 40',
        '3': 'Plus de 50',
        '4': 'Plus de 60'
      }
    },
    quizRatpDevMobco9: {
      title: 'Parmi ces thématiques, lesquelles font partie intégrante de nos engagements RSE ?',
      good_answer_comment:
        'Chez RATP Dev, nous faisons le choix d\'une RSE pragmatique et opérationnelle, imaginée collectivement, applicable partout. D\'une RSE pensée pour donner du sens à notre travail, renforcer la fierté d\'appartenance, et attirer les talents.',
      bad_answer_comment:
        'Non, chez RATP Dev, nous faisons le choix d\'une RSE pragmatique et opérationnelle, imaginée collectivement, applicable partout. D\'une RSE pensée pour donner du sens à notre travail, renforcer la fierté d\'appartenance, et attirer les talents.',
      options: {
        '1': 'Engagement social',
        '2': 'Engagement environnemental',
        '3': 'Engagement sociétal',
        '4': 'Engagement collectif'
      }
    },
    quizRatpDevMobco10: {
      title: 'Quel est l\'intrus ? Parmi ces affirmations, laquelle N\'EST PAS un enseignement de notre étude sur le futur du métro automatique ?',
      good_answer_comment:
        'L\'étude montre justement qu\'il ne faut pas se concentrer uniquement sur la technique, mais aussi sur l\'humain et l\'organisation. Pour découvrir tous les enseignements de cette étude, qui s\'appuie sur plus de 30 entretiens d\'experts menés à travers le monde, scannez le code !',
      good_answer_comment_image: 'quizRatpDevMobco-10-qr.png',
      bad_answer_comment:
        'Non, l\'étude montre justement qu\'il ne faut pas se concentrer uniquement sur la technique, mais aussi sur l\'humain et l\'organisation. Pour découvrir tous les enseignements de cette étude, qui s\'appuie sur plus de 30 entretiens d\'experts menés à travers le monde, scannez le code !',
      bad_answer_comment_image: 'quizRatpDevMobco-10-qr.png',
      options: {
        '1': 'Construire une gouvernance solide et adopter des modèles contractuels collaboratifs',
        '2': 'Faire de l\'automatisation une transformation technocentrée tout en gérant la complexité technique',
        '3': 'Offrir une expérience voyageurs en constante amélioration',
        '4': 'Positionner le métro automatique comme la colonne vertébrale, durable et résiliente, de la transformation urbaine'
      }
    },
    quizMetroMusic1: {
      title: 'En quelle année, le dispositif des Musiciens du métro a-t-il été créé ?',
      good_answer_comment:
        'Bonne réponse ! C’est en 1997 que le dispositif a été lancé, initialement appelé « Mélodies en sous-sol », avant de devenir « Espace métro accords » puis « Musiciens du métro ».',
      bad_answer_comment:
        'La bonne réponse est 1997 ! C’est l’année de la création du dispositif qui portait alors le nom de « Mélodies en sous-sol » avant de devenir « Espace métro accords » puis « Musiciens du métro ».',
      options: {
        '1': '2017',
        '2': '1997',
        '3': '2003'
      }
    },
    quizMetroMusic2: {
      title: 'Parmi ces trois artistes, laquelle a été Musicienne du métro ?',
      good_answer_comment:
        'Exact ! C’est en 2006 que Zaz s’est présentée aux auditions des Musiciens du métro et a obtenu son accréditation, avant de connaitre le succès qu’on lui connait',
      bad_answer_comment:
        'Non, c’est en 2006 que Zaz s’est présentée aux auditions des Musiciens du métro et a obtenu son accréditation, avant de connaitre le succès qu’on lui connait',
      options: {
        '1': 'Clara LUCCIANI',
        '2': 'Santa',
        '3': 'Zaz'
      }
    },
    quizMetroMusic3: {
      title: 'En 2017, quel anniversaire fêtait le dispositif des Musiciens du métro ?',
      good_answer_comment:
        'Bonne réponse ! Le dispositif fêtait ses 20 ans en 2017. Un anniversaire qui avait réuni sur scène, de jeunes talents Musiciens du métro et artistes connus pour un grand concert dans une salle parisienne mythique',
      bad_answer_comment:
        'La bonne réponse est 20 ans. Un anniversaire qui avait réuni sur scène, de jeunes talents Musiciens du métro et artistes connus pour un grand concert dans une salle parisienne mythique',
      options: {
        '1': '20 ans',
        '2': '15 ans',
        '3': '30 ans'
      }
    },
    quizMetroMusic4: {
      title:
        'Dans quelle salle parisienne mythique, le dispositif des Musiciens du métro a-t-il fêté un anniversaire ?',
      good_answer_comment:
        'Exact ! C’était à l’Olympia, à cette occasion, Musiciens du métro s’est affiché en lettres rouges sur la devanture de la cette scène parisienne incontournable !',
      bad_answer_comment:
        'La bonne réponse est l’Olympia. A cette occasion, Musiciens du métro s’est affiché en lettres rouges sur la devanture de la cette scène parisienne incontournable !',
      options: {
        '1': 'L’Olympia',
        '2': 'La Cigale',
        '3': 'Zénith de Paris'
      }
    },
    quizMetroMusic5: {
      title: 'Combien de musiciens du métro sont accrédités à chaque période d’auditions ?',
      good_answer_comment:
        'Bravo ! Ce sont 300 musiciens qui avoir passé le casting obtiennent leurs autorisations de se produire dans les espaces des lignes métro et gares RER opérées par la RATP.',
      bad_answer_comment:
        'Ce sont 300 musiciens qui avoir passé le casting obtiennent leurs autorisations de se produire dans les espaces des lignes métro et gares RER opérées par la RATP.',
      options: {
        '1': '200',
        '2': '300',
        '3': '400'
      }
    },
    quizMetroMusic6: {
      title: 'Combien y a-t-il de périodes d’auditions chaque année ?',
      good_answer_comment:
        'Exact ! Deux sessions d’auditions sont organisées chaque année. A l’automne (septembre/octobre) puis au Printemps (mars/avril).',
      bad_answer_comment:
        'Deux sessions d’auditions sont organisées chaque année. A l’automne (septembre/octobre) puis au Printemps (mars/avril).',
      options: {
        '1': '1',
        '2': '2',
        '3': '3'
      }
    },
    quizMetroMusic7: {
      title: 'Quel est le style musical le plus représenté parmi les Musiciens du métro ?',
      good_answer_comment: 'Bien vu ! La pop représente environ 45 % des musiciens.',
      bad_answer_comment: 'La bonne réponse est la pop qui représente environ 45 % des musiciens.',
      options: {
        '1': 'Musique du monde',
        '2': 'Folk',
        '3': 'Pop'
      }
    },
    quizMetroMusic8: {
      title:
        'Combien d’artistes du Métro sont sélectionnés chaque année pour le festival Solidays ?',
      good_answer_comment:
        'Exact ! Chaque année, le partenariat RATP/Solidays permet à deux artistes du Métro de se produire sur l’une des scènes du festival et intègre ainsi la programmation Solidays.',
      bad_answer_comment:
        'La bonne réponse est 2 artistes.Chaque année, le partenariat RATP/Solidays permet à deux artistes du Métro de se produire sur l’une des scènes du festival et intègre ainsi la programmation Solidays.',
      options: {
        '1': '1',
        '2': '2',
        '3': '3'
      }
    },
    quizMetroMusic9: {
      title: 'Parmi ces personnalités, laquelle a présidé un Tremplin Musiciens du métro ?',
      good_answer_comment:
        'Bonne réponse ! CDepuis 2022, La RATP organise un Tremplin pour faciliter l’émergence de jeunes talents. En Octobre 2024, c’est Christophe WILLEM qui présidait le jury.',
      bad_answer_comment:
        'Depuis 2022, La RATP organise un Tremplin pour faciliter l’émergence de jeunes talents. En Octobre 2024, c’est Christophe WILLEM qui présidait le jury',
      options: {
        '1': 'Céline DION',
        '2': 'Marc LAVOINE',
        '3': 'Christophe WILLEM'
      }
    },
    quizMetroMusic10: {
      title:
        'Quelle station a accueilli une boule à facettes géante pour la Fête de la musique 2024 ?',
      good_answer_comment:
        'Bravo !  Du 19 au 21 juin, une animation Fête de la musique a eu lieu à Jaurès. En lien avec le Disco et la Philharmonie de Paris (partenaire) qui accueille jusqu’au 17août l’exposition DISCO « I’M COMING OUT », une boule à facettes a été installée sous le viaduc.',
      bad_answer_comment:
        'La bonne réponse est Jaurès.  Du 19 au 21 juin, une animation Fête de la musique a eu lieu à Jaurès. En lien avec le Disco et la Philharmonie de Paris (partenaire) qui accueille jusqu’au 17août l’exposition DISCO « I’M COMING OUT », une boule à facettes a été installée sous le viaduc.',
      options: {
        '1': 'Bercy (ligne 14)',
        '2': 'Gambetta (ligne 3)',
        '3': 'Jaurès (ligne 5)'
      }
    },
    quizJep1: {
      title: 'Serge le lapin — En quelle année est né le lapin qui se pince les doigts ?',
      good_answer_comment:
        'Exact ! Serge le Lapin, est un personnage de prévention afin de sensibiliser le jeune public sur certains comportements dangereux à ne pas adopter. Imaginé par la dessinatrice Anne Le Lagadecen 1977, il a connu une première évolution en 1986 sous le crayon de Serge Maury et sa version actuelle qui date de 2014 est l’œuvre de l’agence 4uatre. En rafraîchissant le dessin iconique de Serge Maury, il fut décidé cette même année de donner le nom de Serge à ce personnage désormais mythique. Retrouvez notre mascotte Serge à la Maison de la RATP pour une photo souvenir ! ',
      bad_answer_comment:
        'Pas tout à fait. Serge le Lapin, est un personnage de prévention afin de sensibiliser le jeune public sur certains comportements dangereux à ne pas adopter. Imaginé par la dessinatrice Anne Le Lagadecen 1977, il a connu une première évolution en 1986 sous le crayon de Serge Maury et sa version actuelle qui date de 2014 est l’œuvre de l’agence 4uatre. En rafraîchissant le dessin iconique de Serge Maury, il fut décidé cette même année de donner le nom de Serge à ce personnage désormais mythique. Retrouvez notre mascotte Serge à la Maison de la RATP pour une photo souvenir ! ',
      options: {
        '1': '1977',
        '2': '1986',
        '3': '2014'
      }
    },
    quizJep2: {
      title: 'PILI — Que signifie PILI ?',
      good_answer_comment:
        `Bravo ! Le PILI a fait son apparition en 1937, à l’occasion de l’Exposition universelle. Il permettait aux voyageurs de tracer des itinéraires depuis la station où ils se trouvaient, grâce à un clavier équipé d'un bouton pour chaque destination : le dispositif allumait alors sur le plan une série de petites ampoules, une pour chaque station traversée, afin d'indiquer l'itinéraire le plus rapide à suivre. Près de 180 PILI ont été installés sur le réseau. Devenus obsolètes par leur difficulté de mise à jour pour un réseau en constante évolution, ils disparaissent à partir des années 2000. Retrouvez notre PILI exposé dans la rue intérieure de la Maison de la RATP !`,
      bad_answer_comment:
        `Raté. Le PILI a fait son apparition en 1937, à l’occasion de l’Exposition universelle. Il permettait aux voyageurs de tracer des itinéraires depuis la station où ils se trouvaient, grâce à un clavier équipé d'un bouton pour chaque destination : le dispositif allumait alors sur le plan une série de petites ampoules, une pour chaque station traversée, afin d'indiquer l'itinéraire le plus rapide à suivre. Près de 180 PILI ont été installés sur le réseau. Devenus obsolètes par leur difficulté de mise à jour pour un réseau en constante évolution, ils disparaissent à partir des années 2000. Retrouvez notre PILI exposé dans la rue intérieure de la Maison de la RATP !`,
      options: {
        '1': 'Plan indicateur lumineux d’itinéraires',
        '2': 'Programme itinérant de localisation intuitive',
        '3': 'Pilotage Intelligent de Lignes Informatisées'
      }
    },
    quizJep3: {
      title:
        'Sprague — En quelle année la première rame Sprague‑Thomson a été mise en service sur le réseau de métro parisien ?',
      good_answer_comment:
        'Exact ! Sprague-Thomson est le surnom donné aux premières rames entièrement métalliques du métro de Paris. Ce matériel est resté en service pendant 75 ans, de 1908 à 1983. Retrouvez notre motrice Sprague-Thomson en exposition et en visite libre à la Maison de la RATP, à l’Espace Rapée !',
      bad_answer_comment:
        'Non. Sprague-Thomson est le surnom donné aux premières rames entièrement métalliques du métro de Paris. Ce matériel est resté en service pendant 75 ans, de 1908 à 1983. Retrouvez notre motrice Sprague-Thomson en exposition et en visite libre à la Maison de la RATP, à l’Espace Rapée !',
      options: {
        '1': '1895',
        '2': '1908',
        '3': '1936'
      }
    },
    quizJep4: {
      title:
        'Bus de légende — Quelle ligne a été la dernière à voir circuler des autobus à plateforme (TN4H) ?',
      good_answer_comment:
        `Oui ! Les derniers autobus à plateforme TN4H ont été en service sur la ligne 21 jusqu’au 23 janvier 1971. Leur disparition marque ainsi la fin d'une époque. Retrouvez notre photocall pour une photo souvenir à bord d’un TN4H situé au niveau inférieur du hall. Également, retrouvez nos bus des années trente en circulation sur les balades au départ de la rue intérieure de la Maison de la RATP !`,
      bad_answer_comment:
        `Non. Les derniers autobus à plateforme TN4H ont été en service sur la ligne 21 jusqu’au 23 janvier 1971. Leur disparition marque ainsi la fin d'une époque. Retrouvez notre photocall pour une photo souvenir à bord d’un TN4H situé au niveau inférieur du hall. Également, retrouvez nos bus des années trente en circulation sur les balades au départ de la rue intérieure de la Maison de la RATP !`,
      options: {
        '1': 'Ligne 21',
        '2': 'Ligne 38',
        '3': 'Ligne 72'
      }
    },
    quizJep5: {
      title: 'MS61 — Quelle est l’année de la dernière circulation du MS61 sur le RER A ?',
      good_answer_comment:
        `Exact ! Les premières rames du matériel MS61 sont livrées en 1967, et les lignes RER B sud et RER A en sont progressivement équipées. Le 16 avril 2016, c’est la dernière circulation de ces trains. Retrouvez le simulateur de conduite MS61 à la Maison de la RATP, à l’Espace du Centenaire !`,
      bad_answer_comment:
        `Non. Les premières rames du matériel MS61 sont livrées en 1967, et les lignes RER B sud et RER A en sont progressivement équipées. Le 16 avril 2016, c’est la dernière circulation de ces trains. Retrouvez le simulateur de conduite MS61 à la Maison de la RATP, à l’Espace du Centenaire !`,
      options: {
        '1': '1998',
        '2': '2004',
        '3': '2016'
      }
    },
    quizJep6: {
      title: 'Musiciens du métro — En quelle année le dispositif a-t-il été créé ?',
      good_answer_comment:
        `Bravo ! C’est en 1997 que le dispositif a été lancé, initialement appelé « Mélodies en sous-sol », avant de devenir « Espace Métro accords » puis « Musiciens du Métro ». Les Musiciens du Métro, c’est aujourd’hui 300 accréditations distribuées à chaque saison d’auditions, valables 6 mois, pour permettre aux artistes sélectionnés de se produire dans les espaces du réseau opéré par la RATP. Retrouvez nos Musiciens du Métro à bord des balades en bus des années trente au départ de la rue intérieure de la Maison de la RATP !`,
      bad_answer_comment:
        `Raté. C’est en 1997 que le dispositif a été lancé, initialement appelé « Mélodies en sous-sol », avant de devenir « Espace Métro accords » puis « Musiciens du Métro ». Les Musiciens du Métro, c’est aujourd’hui 300 accréditations distribuées à chaque saison d’auditions, valables 6 mois, pour permettre aux artistes sélectionnés de se produire dans les espaces du réseau opéré par la RATP. Retrouvez nos Musiciens du Métro à bord des balades en bus des années trente au départ de la rue intérieure de la Maison de la RATP !`,
      options: {
        '1': '1997',
        '2': '2003',
        '3': '2017'
      }
    },
    quizJep7: {
      title:
        'Permis transport en commun — En quelle année la première femme machiniste a-t-elle conduit un bus RATP ?',
      good_answer_comment:
        `Exact ! C'est le 17 mai 1961 que Marcelle Claverie, première femme machiniste, prend le volant de son TN4H sur la ligne 49. Retrouvez notre animation Permis transport en commun à la Maison de la RATP, Espace Tisanerie (près du bus TN4H). Également, retrouvez nos images et vidéos d’archives en projection à l’Espace du Centenaire !`,
      bad_answer_comment:
        `Non. C'est le 17 mai 1961 que Marcelle Claverie, première femme machiniste, prend le volant de son TN4H sur la ligne 49. Retrouvez notre animation Permis transport en commun à la Maison de la RATP, Espace Tisanerie (près du bus TN4H). Également, retrouvez nos images et vidéos d’archives en projection à l’Espace du Centenaire !`,
      options: {
        '1': '1949',
        '2': '1961',
        '3': '1974'
      }
    },
    quizJep8: {
      title: 'RATP La Ligne — Qu’est-ce que “RATP La Ligne” ?',
      good_answer_comment:
        `Exact ! En 2020, à l’occasion de ses 70 ans, la RATP a souhaité créer une collection unique d’objets et de vêtements lifestyle urbains, qui s'inspirent de son riche patrimoine historique. Retrouvez notre boutique éphémère RATP La Ligne à la Maison de la RATP, sur la dalle de verre côté entrée principale Rue de Bercy, mais aussi sur ratplaligne.fr !`,
      bad_answer_comment:
        `Non. En 2020, à l’occasion de ses 70 ans, la RATP a souhaité créer une collection unique d’objets et de vêtements lifestyle urbains, qui s'inspirent de son riche patrimoine historique. Retrouvez notre boutique éphémère RATP La Ligne à la Maison de la RATP, sur la dalle de verre côté entrée principale Rue de Bercy, mais aussi sur ratplaligne.fr !`,
      options: {
        '1': 'Une nouvelle ligne de métro ouverte à l’occasion de Jeux Olympiques de 2024',
        '2': 'Une gamme de produits iconiques inspirés du patrimoine de la RATP',
        '3': 'Un recueil de poèmes publié par des voyageurs du réseau RATP'
      }
    },
    quizJep9: {
      title: 'Métro — Quelle ligne de métro fête cette année ses 125 ans ?',
      good_answer_comment:
        `Oui !Le 19 juillet 1900 : la ligne 1 est inaugurée entre la porte Maillot et la porte de Vincennes. Elle a alors pour vocation de relier les principaux sites de l’Exposition universelle de 1900. Retrouvez notre jeu de piste, un parcours immersif et ludique sur la ligne 1 ! Départ avec un livret de jeu qui vous sera remis par nos ambassadeurs dans la rue intérieure à la Maison de la RATP.`,
      bad_answer_comment:
        'Non. Le 19 juillet 1900 : la ligne 1 est inaugurée entre la porte Maillot et la porte de Vincennes. Elle a alors pour vocation de relier les principaux sites de l’Exposition universelle de 1900. Retrouvez notre jeu de piste, un parcours immersif et ludique sur la ligne 1 ! Départ avec un livret de jeu qui vous sera remis par nos ambassadeurs dans la rue intérieure à la Maison de la RATP.',
      options: {
        '1': 'Ligne 1',
        '2': 'Ligne 3',
        '3': 'Ligne 6'
      }
    },
    quizJep10: {
      title:
        'Carreaux de métro — Pourquoi les murs des stations sont-ils habillés de carreaux blancs biseautés ? (plusieurs réponses possibles)',
      good_answer_comment:
        'Parfait ! Le métro de Paris, inauguré en 1900 pour l’Exposition universelle, a dû faire face à plusieurs problématiques dans la conception de ses stations. Le métro étant très faiblement éclairé (une ampoule d’environ 15 W tous les 4,5 mètres), le carreau blanc biseauté reflète au mieux la lumière et augmente son efficacité. Paris a également été touchée de plein fouet par une épidémie de choléra en 1832 et de nombreux parisiens ont succombé à cette maladie, causant un traumatisme. Le carrelage, facile à nettoyer, permettait de limiter le passage de germes. Rendez-vous aux ateliers famille à la Maison de la RATP à l’Espace Rapée pour dessiner et repartir avec votre carreau de métro !',
      bad_answer_comment:
        `Pas exactement. Le métro de Paris, inauguré en 1900 pour l’Exposition universelle, a dû faire face à plusieurs problématiques dans la conception de ses stations. Le métro étant très faiblement éclairé (une ampoule d’environ 15 W tous les 4,5 mètres), le carreau blanc biseauté reflète au mieux la lumière et augmente son efficacité. Paris a également été touchée de plein fouet par une épidémie de choléra en 1832 et de nombreux parisiens ont succombé à cette maladie, causant un traumatisme. Le carrelage, facile à nettoyer, permettait de limiter le passage de germes. Rendez-vous aux ateliers famille à la Maison de la RATP à l’Espace Rapée pour dessiner et repartir avec votre carreau de métro !`,
      options: {
        '1': 'C’était à la mode dans les années 1900',
        '2': 'Pour permettre un meilleur éclairage des stations',
        '3': 'Pour une question d’hygiène'
      }
    },
    quizJep11: {
      title:
        'Tramway — Combien de lignes de tramway sont exploitées par le groupe RATP en Île-de-France ?',
      good_answer_comment:
        `Exact ! Le tramway a disparu des rues de Paris en 1937 et fait son grand retour dans la capitale au début des années 1990. Aujourd’hui, le réseau de tram d’Ile de France compte 15 lignes, dont 9 sont exploitées par le groupe RATP. Retrouvez notre simulateur de conduite tramway à la Maison de la Ratp, à l’Espace du Centenaire !`,
      bad_answer_comment:
        `Non. Le tramway a disparu des rues de Paris en 1937 et fait son grand retour dans la capitale au début des années 1990. Aujourd’hui, le réseau de tram d’Ile de France compte 15 lignes, dont 9 sont exploitées par le groupe RATP. Retrouvez notre simulateur de conduite tramway à la Maison de la Ratp, à l’Espace du Centenaire !`,
      options: {
        '1': '5',
        '2': '9',
        '3': '13'
      }
    },
    quizJep12: {
      title:
        'JEP RATP — Depuis combien d’années la RATP participe-t-elle aux Journées du Patrimoine ?',
      good_answer_comment:
        `Bonne réponse ! Partenaire historique des Journées européennes du patrimoine (JEP), la RATP propose chaque année depuis 1984 (première édition nationale des Journées du Patrimoine), des programmes riches et passionnants, pour découvrir l’histoire des transports parisiens, les coulisses et l’architecture de nombreux sites ainsi que les différents métiers de l’entreprise. Retrouvez chaque année notre programme complet et les ouvertures des inscriptions sur ratp.fr !`,
      bad_answer_comment:
        `Ce n’est pas ça. Partenaire historique des Journées européennes du patrimoine (JEP), la RATP propose chaque année depuis 1984 (première édition nationale des Journées du Patrimoine), des programmes riches et passionnants, pour découvrir l’histoire des transports parisiens, les coulisses et l’architecture de nombreux sites ainsi que les différents métiers de l’entreprise. Retrouvez chaque année notre programme complet et les ouvertures des inscriptions sur ratp.fr !`,
      options: {
        '1': '10 ans',
        '2': '28 ans',
        '3': '41 ans'
      }
    },
    quizGroupUmop1: {
      title: 'Dans combien de pays le groupe RATP est-il implanté ?',
      good_answer_comment:
        'Bravo ! Le groupe RATP est implanté dans les 16 pays suivants : Afrique du Sud, Arabie Saoudite, Australie, Belgique, Canada, Chine RAS de Hong Kong, Égypte, États-Unis, France, Italie, Maroc, Philippines, Qatar, Serbie, Singapour, Suisse.',
      bad_answer_comment:
        'Raté ! Le groupe RATP est implanté dans les 16 pays suivants : Afrique du Sud, Arabie Saoudite, Australie, Belgique, Canada, Chine RAS de Hong Kong, Égypte, États-Unis, France, Italie, Maroc, Philippines, Qatar, Serbie, Singapour, Suisse.',
      options: {
        '1': '10',
        '2': '16',
        '3': '20',
        '4': '25'
      }
    },
    quizGroupUmop2: {
      title: 'Combien de modes de transport le groupe RATP exploite-t-il quotidiennement ?',
      good_answer_comment:
        'Exact ! Le groupe RATP exploite 9 modes de transport au quotidien : métro, tramway, bus urbain et interurbain, train régional, sightseeing, navette maritime, transport à la demande, câble et véhicule autonome.',
      bad_answer_comment:
        'Presque ! Le groupe RATP exploite 9 modes de transport au quotidien : métro, tramway, bus urbain et interurbain, train régional, sightseeing, navette maritime, transport à la demande, câble et véhicule autonome.',
      options: {
        '1': '5',
        '2': '7',
        '3': '9',
        '4': '11'
      }
    },
    quizGroupUmop3: {
      title: 'Combien de différents métiers propose le groupe RATP ?',
      good_answer_comment:
        'C’est juste ! Le groupe RATP propose 270 métiers différents. Voici quelques exemples : conducteur de métro, technicien de maintenance, ingénieur en systèmes de transport, responsable sécurité, chargé de communication, gestionnaire de projets.',
      bad_answer_comment:
        'Presque ! Le groupe RATP propose 270 métiers différents. Voici quelques exemples : conducteur de métro, technicien de maintenance, ingénieur en systèmes de transport, responsable sécurité, chargé de communication, gestionnaire de projets.',
      options: {
        '1': '30',
        '2': '50',
        '3': '120',
        '4': 'plus de 250'
      }
    },
    quizGroupUmop4: {
      title:
        'Combien de salariés du Groupe RATP résident sur les territoires des Yvelines et des Hauts-de-Seine ?',
      good_answer_comment:
        'Exact ! 7 133 salariés RATP y résident, dont 2 547 dans les Yvelines et 4 586 dans les Hauts-de-Seine (chiffres 2024).',
      bad_answer_comment:
        'Pas tout à fait. 7 133 salariés RATP y résident, dont 2 547 dans les Yvelines et 4 586 dans les Hauts-de-Seine (chiffres 2024).',
      options: {
        '1': '2 547',
        '2': '4 586',
        '3': '7 133',
        '4': '8 914'
      }
    },
    quizGroupUmop5: {
      title:
        'À votre avis, combien de voyageurs empruntent chaque jour les transports franciliens opérés par le Groupe RATP pour le compte d\'IDFM ?',
      good_answer_comment:
        'Bravo ! Plus de 9 millions de voyageurs empruntent le réseau d’Île-de-France Mobilités opéré par le Groupe RATP en Île-de-France.',
      bad_answer_comment:
        'Non, plus de 9 millions de voyageurs empruntent le réseau d’Île-de-France Mobilités opéré par le Groupe RATP en Île-de-France.',
      options: {
        '1': 'environ 500 000',
        '2': 'environ 2 millions',
        '3': 'environ 9 millions'
      }
    },
    quizGroupUmop6: {
      title:
        'Depuis le 1er août 2023, quelle filiale exploite de nombreuses lignes de bus dans les Hauts-de-Seine et les Yvelines ?',
      good_answer_comment:
        'Exact ! La filiale RATP Cap Île-de-France est une filiale privée du groupe RATP créée en 2021. Elle répond aux appels d’offre dans le cadre de l’ouverture à la concurrence des transports publics portée par Île-de-France Mobilités, et opère les réseaux de transport qu’elle remporte. Elle propose des solutions de mobilité intégrées, performantes et innovantes au service des territoires et des voyageurs.',
      bad_answer_comment:
        'Non, c’est RATP Cap Île-de-France. Filiale privée du groupe RATP créée en 2021, elle répond aux appels d’offre dans le cadre de l’ouverture à la concurrence des transports publics portée par Île-de-France Mobilités, et opère les réseaux de transport qu’elle remporte.',
      options: {
        '1': 'RATP Expertises',
        '2': 'RATP Cap Île-de-France',
        '3': 'RATP Cap Arc Sud et Ouest'
      }
    },
    quizGroupUmop7: {
      title:
        'À partir du 1er novembre, quelle est la ligne de bus desservant la ville de Versailles exploitée par RATP Cap Île-de-France ?',
      good_answer_comment:
        'Bonne réponse ! La ligne 171 relie Pont de Sèvres au Château de Versailles, via Sèvres, Chaville et Viroflay.',
      bad_answer_comment:
        'Non, c’est la ligne 171 qui relie Pont de Sèvres au Château de Versailles, via Sèvres, Chaville et Viroflay.',
      options: {
        '1': 'la ligne 171',
        '2': 'la ligne 6201',
        '3': 'la ligne 6217'
      }
    },
    quizGroupUmop8: {
      title: 'Quel tramway relie les départements des Hauts-de-Seine et des Yvelines ?',
      good_answer_comment:
        'Exact ! Le tramway T6 relie Châtillon-Montrouge à Viroflay et dessert 12 stations sur 4 communes dans les Hauts-de-Seine et 9 stations sur 2 communes dans les Yvelines.',
      good_answer_comment_image: 'quizGroupUMOP-8-reponse.webp',
      good_answer_comment_image_layout: 'wide',
      bad_answer_comment:
        'Pas tout à fait. Le tramway T6 relie Châtillon-Montrouge à Viroflay et dessert 12 stations sur 4 communes dans les Hauts-de-Seine et 9 stations sur 2 communes dans les Yvelines.',
      bad_answer_comment_image: 'quizGroupUMOP-8-reponse.webp',
      bad_answer_comment_image_layout: 'wide',
      options: {
        '1': 'le T2',
        '2': 'le T6',
        '3': 'le T13'
      }
    },
    quizGroupUmop9: {
      title:
        'Quel est le nombre de gares desservies par le RER B sur les territoires des Hauts-de-Seine et des Yvelines ?',
      good_answer_comment:
        'Bravo ! 11 gares au total dont 2 pour le tronçon central, 6 sur la branche St Rémy et 3 sur la branche Robinson.',
      good_answer_comment_image: 'quizGroupUMOP-9-reponse.webp',
      good_answer_comment_image_layout: 'wide',
      bad_answer_comment:
        'Non, ce sont 11 gares au total dont 2 pour le tronçon central, 6 sur la branche St Rémy et 3 sur la branche Robinson.',
      bad_answer_comment_image: 'quizGroupUMOP-9-reponse.webp',
      bad_answer_comment_image_layout: 'wide',
      options: {
        '1': '6',
        '2': '9',
        '3': '11'
      }
    },
    quizGroupUmop10: {
      title:
        'Quel est le nombre de communes desservies par le RER A dans les Yvelines et les Hauts-de-Seine ?',
      good_answer_comment:
        'Exact ! 13 communes (Chatou, Le Vésinet, St Germain-en-Laye, Conflans-Ste-Honorine, Houilles, Maisons-Laffitte, Poissy, Sartrouville, Achères, Rueil-Malmaison, Nanterre, Puteaux, Courbevoie) hébergent des gares.',
      bad_answer_comment:
        'Pas tout à fait. 13 communes (Chatou, Le Vésinet, St Germain-en-Laye, Conflans-Ste-Honorine, Houilles, Maisons-Laffitte, Poissy, Sartrouville, Achères, Rueil-Malmaison, Nanterre, Puteaux, Courbevoie) hébergent des gares.',
      options: {
        '1': '10',
        '2': '13',
        '3': '17'
      }
    },
    quizGroupUmop11: {
      title:
        'Quelles lignes du réseau Grand Paris Express (GPE) desserviront les territoires des Hauts-de-Seine et des Yvelines ?',
      good_answer_comment:
        'Exact ! Les lignes 15 et 18. La ligne 15 (sud et ouest) reliera la gare de Bagneux à la gare Les Grésillons (Gennevilliers). La ligne 18 desservira Versailles Chantiers, Satory, St Quentin Est et la gare d’Antony pôle.',
      bad_answer_comment:
        'Non, ce sont les lignes 15 et 18. La ligne 15 (sud et ouest) reliera la gare de Bagneux à la gare Les Grésillons (Gennevilliers). La ligne 18 desservira Versailles Chantiers, Satory, St Quentin Est et la gare d’Antony pôle.',
      options: {
        '1': 'Lignes 15 et 16',
        '2': 'Lignes 16 et 17',
        '3': 'Lignes 15 et 18'
      }
    },
    quizGroupUmop12: {
      title: 'Savez-vous quel est l’objet le plus fréquemment oublié dans les transports ?',
      good_answer_comment: 'Bravo ! L’objet le plus fréquemment oublié dans les transports est un parapluie.',
      bad_answer_comment:
        'Non, l’objet le plus fréquemment oublié dans les transports est un parapluie.',
      options: {
        '1': 'un parapluie',
        '2': 'un sac',
        '3': 'un téléphone'
      }
    }
  }
} as const

export default fr
